export default "__VITE_ASSET__dPSNZKBD__"